import Carrousel from './Carrousel';
import BannerTextScroll from './BannerTextScroll';

const CommunicationBanner = ({ maintenanceData }) => {
   return Boolean(maintenanceData?.data?.isActive) ? (
      <BannerTextScroll message={maintenanceData?.data?.message} />
   ) : (
      <Carrousel />
   );
};
export default CommunicationBanner;
